import { useOnlineStatus } from '../hooks/useOnlineStatus.js';
import { labels } from '../labels.js';
import { Icon } from './Icon.js';

export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div role="status" className="status-bar status-bar--warning">
      <Icon name="wifi-off" size={18} />
      {labels.errors.network}
    </div>
  );
}
